<template>
  <div class="container is-uppercase has-text-weight-bold h-max">
    <Header />
    <div class="p-md">
      {{ $t('The transaction was successful. Thank you for using the service.') }} <br>
      {{ $t('You will be redirected to the site in a moment. If this does not happen in a few seconds, click Next.') }}
    </div>
    <div class="has-text-centered w-max m-t-md">
      <router-link :to="{ name: 'CreateProfile' }" class="button p-t-sm p-b-sm p-l-lg p-r-lg has-background-primary has-text-white">{{ $t('Next') }}</router-link>
    </div>
    <Footer class="fixed-bl fixed-br" />
  </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'PaymentConfirm',
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage) {
      const saleIdArr = window.location.hash.match(/\?saleId=([a-z0-9]+)/)
      if (saleIdArr instanceof Array && saleIdArr.length == 2) {
        window.localStorage.setItem('saleId', saleIdArr[1])
      }

      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'LP' })
      }
    }

    const redirect = (() => this.$router.push({ name: 'CreateProfile' })).bind(this)
    setTimeout(redirect, 5000)
  },
  components: {
    Header,
    Footer
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Settings/PaymentConfirm.vue